import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { LABELS } from "@/lib/monteurOptions";
import { PortfolioGallery } from "@/components/PortfolioGallery";
import { Send, MapPin, Star, Truck, Languages, Wrench, UserCheck, CalendarDays } from "lucide-react";

const SPEC_LABEL = { ramen: "Ramen", deuren: "Deuren", beide: "Ramen & Deuren" };

export function MonteurCard({ monteur: m, onHire, onAgenda }) {
  return (
    <div data-testid="monteur-card" className="bg-white border border-slate-200 rounded-md p-5">
      <div className="flex items-center gap-3 mb-3">
        <Avatar className="rounded-sm w-12 h-12 bg-slate-950">
          <AvatarFallback className="rounded-sm bg-slate-950 text-orange-500 font-bold">
            {m.name?.slice(0, 2).toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <div>
          <h3 className="font-display font-bold text-slate-950">{m.name}</h3>
          <p className="text-xs text-slate-500 flex items-center gap-1">
            <MapPin className="w-3 h-3 text-orange-500" />
            {m.provincie || m.regio || "Provincie onbekend"}
          </p>
        </div>
        {m.beschikbaar && <span className="ml-auto w-2.5 h-2.5 rounded-full bg-green-500" title="Beschikbaar" />}
      </div>
      {m.bio && <p className="text-sm text-slate-600 mb-3 line-clamp-2">{m.bio}</p>}
      <div className="flex flex-wrap gap-2 text-xs mb-4">
        <span className="bg-slate-100 px-2 py-0.5 rounded-sm font-semibold">{SPEC_LABEL[m.specialisatie] || m.specialisatie}</span>
        <span className="bg-slate-100 px-2 py-0.5 rounded-sm flex items-center gap-1"><Star className="w-3 h-3" /> {m.ervaring_jaren} jr ervaring</span>
        <span className="bg-orange-50 text-orange-700 px-2 py-0.5 rounded-sm font-bold">€{m.uurtarief}/uur</span>
      </div>
      <div className="space-y-1.5 text-xs text-slate-600 border-t border-slate-100 pt-3 mb-4">
        {m.werkstatuut && (
          <p className="flex items-center gap-1.5"><UserCheck className="w-3.5 h-3.5 text-slate-400" /> {LABELS[m.werkstatuut] || m.werkstatuut}</p>
        )}
        {m.vervoer && (
          <p className="flex items-center gap-1.5"><Truck className="w-3.5 h-3.5 text-slate-400" /> {LABELS[m.vervoer] || m.vervoer}
            {m.rijbewijs_categorieen?.length ? ` · Rijbewijs ${m.rijbewijs_categorieen.join(", ")}` : ""}</p>
        )}
        {(m.spec_montage?.length || m.spec_afwerking?.length) ? (
          <p className="flex items-start gap-1.5"><Wrench className="w-3.5 h-3.5 text-slate-400 mt-0.5" />
            <span>{[...(m.spec_montage || []), ...(m.spec_afwerking || [])].map((s) => LABELS[s] || s).join(", ")}</span></p>
        ) : null}
        {m.talen?.length ? (
          <p className="flex items-center gap-1.5"><Languages className="w-3.5 h-3.5 text-slate-400" /> {m.talen.join(", ")}
            {m.moedertaal ? ` · ${m.moedertaal} (moedertaal)` : ""}</p>
        ) : null}
        {m.leiding_team && (
          <p className="flex items-center gap-1.5 font-semibold text-slate-700"><Star className="w-3.5 h-3.5 text-orange-500" /> Kan leiding geven aan een team</p>
        )}
        {m.werkmateriaal === "eigen" && (
          <p className="flex items-center gap-1.5"><Wrench className="w-3.5 h-3.5 text-slate-400" /> Eigen werkmateriaal</p>
        )}
      </div>
      <PortfolioGallery photos={m.portfolio} accent="orange" label="Werk van deze professional" />
      <div className="flex gap-2 mt-4">
        <Button data-testid="hire-monteur-btn" onClick={() => onHire(m)}
          className="flex-1 bg-slate-950 hover:bg-orange-500 text-white rounded-sm font-bold transition-colors">
          <Send className="w-4 h-4 mr-2" /> Aanvraag
        </Button>
        <Button data-testid="view-agenda-btn" onClick={() => onAgenda(m)} variant="outline"
          className="rounded-sm font-bold border-slate-300">
          <CalendarDays className="w-4 h-4 mr-2" /> Agenda
        </Button>
      </div>
    </div>
  );
}
